import React from "react";
import Skeleton from "react-loading-skeleton";

const ProductInfoDetailsSkeleton: React.FC = () => {
  return (
    <div className="product-info-details">
      {/* ProductHeader Skeleton */}
      <Skeleton width="40%" height={16} />
      <Skeleton height={36} style={{ margin: "0.5rem 0" }} />

      {/* ProductPrice Skeleton */}
      <Skeleton height={24} width="30%" style={{ marginBottom: "1rem" }} />

      {/* ProductShortDescription Skeleton */}
      <Skeleton count={2} height={18} style={{ marginBottom: "0.5rem" }} />

      {/* ProductAttributes Skeleton */}
      <div
        className="product-info-details__attributes"
        style={{ marginTop: "1.5rem" }}
      >
        <Skeleton width="30%" height={20} style={{ marginBottom: "0.5rem" }} />
        <div style={{ display: "flex", gap: "8px" }}>
          <Skeleton circle width={32} height={32} />
          <Skeleton circle width={32} height={32} />
          <Skeleton circle width={32} height={32} />
        </div>
      </div>

      {/* ProductActions Skeleton */}
      <div
        className="product-info-details__purchase-actions"
        style={{ marginTop: "1.5rem" }}
      >
        <Skeleton height={44} width={140} />
        <Skeleton height={44} />
      </div>

      {/* ProductMeta Skeleton */}
      <div
        className="product-info-details__meta"
        style={{
          marginTop: "1.5rem",
          paddingTop: "1rem",
          borderTop: "1px solid var(--color-border-light)",
        }}
      >
        <Skeleton count={2} height={16} style={{ marginBottom: "0.5rem" }} />
      </div>
    </div>
  );
};

export default ProductInfoDetailsSkeleton;
